export function buildUserNameToUse(user) {
  if (user.displayData?.nickName && user.displayData?.lastName) {
    return `${user.displayData.nickName} ${user.displayData.lastName}`;
  }
  if (user.displayData?.nickName) {
    return user.displayData.nickName;
  }
  return user.displayData.name;
}
